/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChangeRequestCreateOrUpdateRequest,
  DraftDetails,
  MiddlewareError,
} from '../models/index';
import {
    ChangeRequestCreateOrUpdateRequestFromJSON,
    ChangeRequestCreateOrUpdateRequestToJSON,
    DraftDetailsFromJSON,
    DraftDetailsToJSON,
    MiddlewareErrorFromJSON,
    MiddlewareErrorToJSON,
} from '../models/index';

export interface DeleteStoreProfileDraftOfCurrentRetailerRequest {
    uuid: string;
}

export interface GetStoreProfileDraftDetailsOfCurrentRetailerRequest {
    uuid: string;
}

export interface UpdateStoreProfileDetailsDraftOfCurrentRetailerRequest {
    changeRequestCreateOrUpdateRequest: ChangeRequestCreateOrUpdateRequest;
}

/**
 * 
 */
export class StoreProfileDraftResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteStoreProfileDraftOfCurrentRetailer without sending the request
     */
    async deleteStoreProfileDraftOfCurrentRetailerRequestOpts(requestParameters: DeleteStoreProfileDraftOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteStoreProfileDraftOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile/draft/{uuid}`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteStoreProfileDraftOfCurrentRetailerRaw(requestParameters: DeleteStoreProfileDraftOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteStoreProfileDraftOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteStoreProfileDraftOfCurrentRetailer(requestParameters: DeleteStoreProfileDraftOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStoreProfileDraftOfCurrentRetailerRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getStoreProfileDraftDetailsOfCurrentRetailer without sending the request
     */
    async getStoreProfileDraftDetailsOfCurrentRetailerRequestOpts(requestParameters: GetStoreProfileDraftDetailsOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getStoreProfileDraftDetailsOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile/draft/{uuid}`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getStoreProfileDraftDetailsOfCurrentRetailerRaw(requestParameters: GetStoreProfileDraftDetailsOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DraftDetails>> {
        const requestOptions = await this.getStoreProfileDraftDetailsOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DraftDetailsFromJSON(jsonValue));
    }

    /**
     */
    async getStoreProfileDraftDetailsOfCurrentRetailer(requestParameters: GetStoreProfileDraftDetailsOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DraftDetails> {
        const response = await this.getStoreProfileDraftDetailsOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateStoreProfileDetailsDraftOfCurrentRetailer without sending the request
     */
    async updateStoreProfileDetailsDraftOfCurrentRetailerRequestOpts(requestParameters: UpdateStoreProfileDetailsDraftOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['changeRequestCreateOrUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateOrUpdateRequest',
                'Required parameter "changeRequestCreateOrUpdateRequest" was null or undefined when calling updateStoreProfileDetailsDraftOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/store-profile/updatedraft`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateOrUpdateRequestToJSON(requestParameters['changeRequestCreateOrUpdateRequest']),
        };
    }

    /**
     */
    async updateStoreProfileDetailsDraftOfCurrentRetailerRaw(requestParameters: UpdateStoreProfileDetailsDraftOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateStoreProfileDetailsDraftOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateStoreProfileDetailsDraftOfCurrentRetailer(requestParameters: UpdateStoreProfileDetailsDraftOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStoreProfileDetailsDraftOfCurrentRetailerRaw(requestParameters, initOverrides);
    }

}
